import { 
  doc, 
  getDoc, 
  setDoc
} from 'firebase/firestore';
import { db } from './firebaseClient';
import { CertificateTemplate } from '../types';

const TEMPLATE_COLLECTION = 'certificate_templates';
const DEFAULT_TEMPLATE_ID = 'default_selection_cert';

const DEFAULT_TEMPLATE: CertificateTemplate = {
  id: DEFAULT_TEMPLATE_ID,
  title: 'CERTIFICATE OF SELECTION',
  subTitle: 'Kreed Odisha Sports Excellence Program',
  bodyText: 'This is to certify that {{name}} with Registration ID {{id}} has been selected for the Kreed Odisha Sports Excellence Program based on their outstanding sports achievements.',
  footerText: 'Issued on {{date}}',
  issuedBy: 'Director, Kreed Odisha',
  organizationName: 'KREED ODISHA',
  updatedAt: new Date()
};

export const getCertificateTemplate = async (id: string = DEFAULT_TEMPLATE_ID): Promise<CertificateTemplate> => {
  try {
    const docRef = doc(db, TEMPLATE_COLLECTION, id);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      const data = docSnap.data();
      return {
        ...data,
        updatedAt: data.updatedAt?.toDate() || new Date()
      } as CertificateTemplate;
    } else {
      await setDoc(docRef, DEFAULT_TEMPLATE);
      return DEFAULT_TEMPLATE;
    }
  } catch (error) {
    console.error('Error fetching certificate template:', error);
    return DEFAULT_TEMPLATE;
  }
};

export const updateCertificateTemplate = async (template: CertificateTemplate): Promise<void> => {
  try {
    const docRef = doc(db, TEMPLATE_COLLECTION, template.id);
    await setDoc(docRef, {
      ...template,
      updatedAt: new Date()
    });
  } catch (error) {
    console.error('Error updating certificate template:', error);
    throw error;
  }
};
